import { createSelector } from "reselect";
const EMPTY_ARRAY = [];

export const selectListDatasetDetail = (state) =>
  state.datasetDetail_v2.entities.items.byId;

export const selectQuery = (state, queryKey) => state.queries?.[queryKey];

export const makeSelectIds = () =>
  createSelector([selectQuery], (query) => query?.ids || EMPTY_ARRAY);

export const selectCurrentPage = (state) =>
  state.datasetDetail_v2.pagination.currentPage;

export const selectLimit = (state) =>
  state.datasetDetail_v2.pagination.pageSize;

export const selectDatasetName = (state) => state.datasetDetail_v2.datasetName;

export const selectLoading = (state) => state.datasetDetail_v2.isLoading;
export const selectTotalPage = (state) =>
  state.datasetDetail_v2.pagination.totalPage;
export const selectTotalItem = (state) =>
  state.datasetDetail_v2.pagination.totalItem;

export const selectIsSelected = (state, id) =>
  !!state.datasetDetail_v2.selection.selectedIds[id];

export const selectIsAllSelected = (state, queryKey) => {
  const ids = state.datasetDetail_v2.queries?.[queryKey]?.ids || EMPTY_ARRAY;
  if (ids.length === 0) return false;
  const selected = state.datasetDetail_v2.selection.selectedIds;
  return ids.every((id) => selected[id.toString()]);
};

export const selectProjectRole = (state) => state.datasetDetail_v2.projectRole;

export const selectModuleRoleData = (state) => state.datasetDetail_v2.roleData;
export const selectQueriesField = (state) =>
  state.datasetDetail_v2.queries.field;
export const selectIsOpenSmartTag = (state) =>
  state.datasetDetail_v2.isOpenSmartTag;
export const selectSourceId = (state) => state.datasetDetail_v2.sourceId;
export const selectIsOpenAdvancedSearchDrawer = (state) =>
  state.datasetDetail_v2.isOpenAdvancedSearchDrawer;
export const selectImageSizeFrom = (state) =>
  state.datasetDetail_v2.advancedFilters.imageSize.from;
export const selectImageSizeTo = (state) =>
  state.datasetDetail_v2.advancedFilters.imageSize.to;
export const selectLabel = (state) =>
  state.datasetDetail_v2.advancedFilters.labelIds;
export const selectLabelExclude = (state) =>
  state.datasetDetail_v2.advancedFilters.labelExcludeIds;
export const selectDatasetIds = (state) =>
  state.datasetDetail_v2.advancedFilters.datasetIds;
export const selectLabelSize = (state) =>
  state.datasetDetail_v2.advancedFilters.labelingSize;
export const selectResolution = (state) =>
  state.datasetDetail_v2.advancedFilters.resolution;
export const selectSearchText = (state) =>
  state.datasetDetail_v2.advancedFilters.searchByText;
export const selectStatus = (state) =>
  state.datasetDetail_v2.advancedFilters.status;
export const selectTagsInclude = (state) =>
  state.datasetDetail_v2.advancedFilters.tagsInclude;
export const selectTagsExclude = (state) =>
  state.datasetDetail_v2.advancedFilters.tagsExclude;
export const selectQueriesByAdvanced = (state) =>
  state.datasetDetail_v2.advancedFilters;
export const selectIsAdvancedSearch = (state) =>
  state.datasetDetail_v2.isAdvancedSearch;
export const selectAdvancedFilterApplies = (state) =>
  state.datasetDetail_v2.advancedFiltersApply;
export const selectAdvancedFilterByLabeler = (state) =>
  state.datasetDetail_v2.advancedFilters.labeler;
export const selectAdvancedFilterByReviewer = (state) =>
  state.datasetDetail_v2.advancedFilters.reviewer;
export const selectCurrentDatasetId = (state) =>
  state.datasetDetail_v2.currentDatasetId;
export const selectCurrentViewType = (state) => state.datasetDetail_v2.viewType;
export const selectIsOpenImportDrawer = (state) =>
  state.datasetDetail_v2.isOpenImportDataDrawer;
export const selectIsOpenExportDrawer = (state) =>
  state.datasetDetail_v2.isOpenModalExportDataDrawer;
export const selectIsOpenAssignMemberDrawer = (state) =>
  state.datasetDetail_v2.isOpenAssignMemberDrawer;
const selectSelectedIdsMap = (state) =>
  state.datasetDetail_v2.selection.selectedIds;
export const selectSelectedIds = createSelector(
  [selectSelectedIdsMap],
  (selectedIds) => Object.keys(selectedIds),
);
export const selectIsOpenUnassignModal = (state) =>
  state.datasetDetail_v2.isOpenConfirmModalUnAssign;

export const selectCurrentIds = (state) => {
  const key = state.datasetDetail_v2.ui.currentQueryKey;

  return state.datasetDetail_v2.queries[key]?.ids || [];
};

export const selectIsOpenDeleteModal = (state) =>
  state.datasetDetail_v2.isOpenDeleteModal;

export const selectCountPerRow = (state) =>
  state.datasetDetail_v2.pagination.countsPerRow;
export const selectDatasets = (state) => state.datasetDetail_v2.datasets;
export const selectMattrixPermission = (state) =>
  state.datasetDetail_v2.mattrixPermission;

export const selectItemById = (state, sourceId) =>
  state.datasetDetail_v2.entities.items.byId[sourceId];
export const selectIsOpenAutoLabelDialog = (state) =>
  state.datasetDetail_v2.isOpenAutoLabelDialog;
export const selectTargetLabels = (state) =>
  state.datasetDetail_v2.targetLabels;
export const selectIsLoadingAutoLabels = (state) =>
  state.datasetDetail_v2.isLoadingAutoLabels;
export const selectIsLoadingBulkStatus = (state) =>
  state.datasetDetail_v2.isLoadingBulkStatus;
export const selectObjectDataset = createSelector(
  [selectDatasets],
  (datasets) => Object.fromEntries(datasets.map((item) => [item.value, item])),
);
